module.exports = __webpack_public_path__ + "img/gallery-image--2.2241f926.png";